import { ILandingSection } from "../../../data/interfaces"

/* Protopia Ecosystem component */
export interface IWaypointProps {
    section: ILandingSection
}
const Waypoint = (props: IWaypointProps): JSX.Element => {
    return <div className='pe-waypoint-container'>
       
    </div>
}
export default Waypoint